module.exports = __webpack_public_path__ + "static/img/gaozhonglishi6.7c88c90e.jpg";